module.exports = __webpack_public_path__ + "img/wh.91a56f17.png";